import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { consumeAuthRedirectContext } from "../../app/utils/authRedirect.js";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../css/SessionTimeout.css";

export default function SessionTimeout() {
  const location = useLocation();
  const redirectContext = useMemo(() => consumeAuthRedirectContext(), []);
  const search = new URLSearchParams(location.search);
  const authRequired =
    redirectContext.reason === "auth_required" ||
    location.state?.reason === "auth_required" ||
    search.get("reason") === "auth_required";

  return (
    <div className="session-timeout-page">
      <Navbar />
      <main className="session-timeout-main">
        <div className="session-timeout-card">
          <p className="session-timeout-eyebrow">
            {authRequired ? "Sign in required" : "Session ended"}
          </p>
          <h1 className="session-timeout-title">Please sign in again</h1>
          <p className="session-timeout-text">
            {authRequired
              ? "You need to sign in to open that page. Choose how you want to sign in."
              : "Your session timed out for security. Choose how you want to sign back in."}
          </p>
          <div className="session-timeout-actions">
            <Link to="/admin-login" className="session-timeout-btn session-timeout-btn--primary">
              Admin login
            </Link>
            <Link to="/user-login" className="session-timeout-btn">
              Staff login
            </Link>
            <Link to="/donor-login" className="session-timeout-btn">
              Donor login
            </Link>
            <Link to="/student-login" className="session-timeout-btn">
              Student login
            </Link>
          </div>
          <Link to="/" className="session-timeout-home">
            Back to home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
